import React, { Component } from "react";

export default class Content extends Component {
    constructor(props) {
        super(props);
    }

    render() {
        const { data = {} } = this.props;
        const htmlData =  data.data || {};
        return <div className="content_s new_content_s" id="scrollBox" dangerouslySetInnerHTML={{ __html: htmlData.html }}>
        </div>
    }
}


// WEBPACK FOOTER //
// ./src/component/agreement/Content.js